import { units, color } from '@m/alchemy-theme';
import { Field } from '@m/alchemy-ui/Field';
import styled from 'styled-components';

export const FieldsGroup = styled.div`
  padding: ${units(2)};
  border: 1px solid ${color('line')};
  border-radius: ${units(2)};
  margin-bottom: ${units(2)};
`;

export const StyledField = styled(Field)`
  margin-bottom: ${units(2)};

  &:last-child {
    margin-bottom: 0;
  }
`;
